import React from "react";
import { SvgProps } from "./Form";

export const OpenEmail = (props: SvgProps) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clip-path="url(#clip0_5470_5617)">
      <path
        d="M15.178 5.59464L10.3567 0.975978C9.73331 0.352796 8.8885 0.00188161 8.00706 7.54481e-06C7.12563 -0.00186652 6.27934 0.345453 5.65333 0.965978L0.822 5.59464C0.562714 5.84392 0.356299 6.14287 0.215071 6.47366C0.0738439 6.80445 0.000698673 7.1603 0 7.51998L0 16H16V7.51998C15.9993 7.1603 15.9262 6.80445 15.7849 6.47366C15.6437 6.14287 15.4373 5.84392 15.178 5.59464ZM6.586 1.91864C6.96816 1.55194 7.47785 1.34806 8.00749 1.35005C8.53713 1.35204 9.04527 1.55974 9.42467 1.92931L13.9233 6.23864L9.414 10.748C9.03288 11.1113 8.52654 11.3139 8 11.3139C7.47346 11.3139 6.96712 11.1113 6.586 10.748L2.07667 6.23864L6.586 1.91864ZM14.6667 14.6666H1.33333V7.51998C1.33333 7.47731 1.342 7.43598 1.346 7.39331L5.64333 11.6906C6.26843 12.3155 7.11612 12.6666 8 12.6666C8.88388 12.6666 9.73158 12.3155 10.3567 11.6906L14.654 7.39331C14.658 7.43598 14.6667 7.47731 14.6667 7.51998V14.6666Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_5470_5617">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
